import { onDownArrowPressedSearchInput } from '../actions/internalActions';
import { changeSelectedSuggestionViaKeyboard } from '../actions/publicActions';
import { getStore } from '../store/store';
import { orchestrator } from 'satcheljs';
export default orchestrator(onDownArrowPressedSearchInput, function () {
    // Bail if there isn't a complete suggestion set in the store.
    var currentSuggestionSet = getStore().currentSuggestions;
    if (!currentSuggestionSet || !currentSuggestionSet.IsComplete) {
        return;
    }
    var selectedSuggestionIndex = getStore().selectedSuggestionIndex;
    var suggestionsCount = currentSuggestionSet.Suggestions.length;
    /**
     * If user isn't already at the bottom of the SuggestionsContextMenu (i.e.
     * selectedSuggestionIndex === suggestionsCount - 1) then we'll move the
     * selected index.
     */
    if (selectedSuggestionIndex < suggestionsCount - 1) {
        // User is going "down" in the UI, so increase the index.
        var indexToSelect = selectedSuggestionIndex + 1;
        // Get suggestion to be selected.
        var suggestionToSelect = currentSuggestionSet.Suggestions[indexToSelect];
        // Dispatch action to change selected index.
        changeSelectedSuggestionViaKeyboard(indexToSelect, suggestionToSelect);
    }
});
//# sourceMappingURL=onDownArrowPressedSearchInputOrchestrator.js.map